<template>
	<v-hover v-slot:default="{ hover }" open-delay="200" v-if="action">
		<v-card @click="clicked()" ripple flat :class="hover ? 'v-list-item--active active primary--text ' + cardClass : cardClass">
			<v-card-text class="pa-0">
				<v-row no-gutters :justify="right ? 'end' : 'start'" align="center" class="ma-0">
					<v-col cols="12" xs="12" justify="center">
						<v-icon :color="color" dense :class="small ? 'mr-1' : 'mr-2'" v-if="icon">{{ icon }}</v-icon>
						<span :class="boldtitle ? 'subtitle-1 pr-1 font-weight-bold' : 'subtitle-1 pr-1'" v-if="contenttitle" v-html="contenttitle + ':'"></span>
						<span :class="contentClass" style="white-space: pre-line; word-break: break-word" v-if="!readmore && !loading" v-html="contentvalue"></span>
						<read-more-text :class="contentClass" style="white-space: pre-line; word-break: break-word" v-if="readmore && !loading" :text="contentvalue"></read-more-text>
						<v-progress-circular size="16" class="ma-1" width="2" indeterminate v-if="loading"></v-progress-circular>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-hover>
	<v-row no-gutters :justify="right ? 'end' : 'start'" align="center" class="ma-0" v-else>
		<v-col cols="12" xs="12" justify="center">
			<v-icon :color="color" dense :class="small ? 'mr-1' : 'mr-2'" v-if="icon">{{ icon }}</v-icon>
			<span :class="boldtitle ? 'subtitle-1 pr-1 font-weight-bold' : 'subtitle-1 pr-1'" v-if="contenttitle" v-html="contenttitle + ':'"></span>
			<span :class="contentClass" style="white-space: pre-line; word-break: break-word" v-if="!readmore && !loading" v-html="contentvalue"></span>
			<read-more-text :class="contentClass" style="white-space: pre-line; word-break: break-word" v-if="readmore && !loading" :text="contentvalue"></read-more-text>
			<v-progress-circular size="16" class="ma-1" width="2" indeterminate v-if="loading"></v-progress-circular>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data: () => ({}),
	props: {
		bold: {
			type: Boolean,
			default: false,
		},
		boldtitle: {
			type: Boolean,
			default: false,
		},
		readmore: {
			type: Boolean,
			default: false,
		},
		right: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: null,
		},
		contenttitle: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: null,
		},
		contentvalue: {
			type: [String, Number],
			default: null,
		},
		loading: {
			type: Boolean,
			default: true,
		},
		error: {
			type: Boolean,
			default: false,
		},
		transparent: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		action: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		contentClass() {
			let contentclass = "";
			if (this.bold) {
				contentclass += "font-weight-bold ";
			}
			if (this.small) {
				contentclass += "post_content ";
			} else {
				contentclass += "subtitle-1 ";
			}
			return contentclass;
		},
		cardClass() {
			let classe = "ma-0 ";
			if (this.error && !this.loading) {
				classe += "error--text ";
			}
			/*
            if (this.$vuetify.breakpoint.xsOnly == false) {
                classe += 'px-2'
            }
            */
			return classe;
		},
	},
	methods: {
		clicked() {
			this.$emit("click");
		},
	},
};
</script>
